module.exports = __webpack_public_path__ + "static/img/icon_hitem5.aaca0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem5.png
// module id = rDOD
// module chunks = 21